
// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Views
import StatusOrder from "views/Order/application/status";


class RouteOrderStatus extends Component {

    render() {
        const { match } = this.props;
        return (
            <div className={"man-content"}>
                <StatusOrder id={match.params.id} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(RouteOrderStatus);

export default withRouter(connect_);